/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var MicroFrontendTypeEnum;
(function (MicroFrontendTypeEnum) {
    MicroFrontendTypeEnum["UNKNOWN"] = "UNKNOWN";
    MicroFrontendTypeEnum["SINGLE_SPA"] = "SINGLE_SPA";
    MicroFrontendTypeEnum["FEDERATED_MODULE"] = "FEDERATED_MODULE";
    MicroFrontendTypeEnum["WEB_COMPONENT"] = "WEB_COMPONENT";
    MicroFrontendTypeEnum["VANILLA_SPA"] = "VANILLA_SPA";
})(MicroFrontendTypeEnum || (MicroFrontendTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWljcm8tZnJvbnRlbmQtdHlwZS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZGVscy9taWNyby1mcm9udGVuZHMvbWljcm8tZnJvbnRlbmQtdHlwZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsTUFBTSxDQUFOLElBQVkscUJBTVg7QUFORCxXQUFZLHFCQUFxQjtJQUM3Qiw0Q0FBbUIsQ0FBQTtJQUNuQixrREFBeUIsQ0FBQTtJQUN6Qiw4REFBcUMsQ0FBQTtJQUNyQyx3REFBK0IsQ0FBQTtJQUMvQixvREFBMkIsQ0FBQTtBQUMvQixDQUFDLEVBTlcscUJBQXFCLEtBQXJCLHFCQUFxQixRQU1oQyJ9